<template>
  <div
    class="container"
    :style="cssVars"
  >
    <h1 class="message">{{ messageValue }}</h1>
    <FormButton
      v-if="!hideBtn"
      class="form-button"
      variant="primary"
      @click="$emit('close-unavailable')"
      @keypress.enter="$emit('close-unavailable')"
    >
      {{ $t('forms.goToFormsList') }}
    </FormButton>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useNuxtApp } from '#imports';
import { useMainStore } from '../../../../stores/mainStore.js';
import { useAlertBannerStore } from '../../../../stores/alertBannerStore.js';
import FormButton from '../components/dscl/FormButton';

defineOptions({ name: 'UnavailableForm' });

const props = defineProps({
  hideBtn: {
    type: Boolean,
    default: false,
  },
  message: {
    type: String,
    default: '',
  },
});

defineEmits(['close-unavailable']);

const { $t } = useNuxtApp();
const mainStore = useMainStore();
const alertBannerStore = useAlertBannerStore();

const messageValue = computed(() => props.message || $t('forms.unavailableForm'));

const headingColor = computed(() => mainStore.getThemeHeadingColor);
const overlayColor = computed(() => alertBannerStore.getThemeAlertShadowOverlay);

const cssVars = computed(() => {
  const themeColor = headingColor.value || '#333';
  const themeColorTwo = `${themeColor}05`;
  const themeColorFive = `${themeColor}13`;
  const themeColorTwenty = `${themeColor}33`;
  return {
    '--primary-forms-color': themeColor,
    '--light-forms-color': themeColorFive,
    '--medium-forms-color': themeColorTwenty,
    '--empty-forms-color': themeColorTwo,
    '--overlay-color': overlayColor.value,
  };
});
</script>

<style lang="scss" scoped>
.container {
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .message {
    color: var(--primary-forms-color);
    margin-bottom: 64px;
    font-size: 36px;
    line-height: 48px;
  }
  .form-button {
    width: 138px;
    height: 36px;
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
    margin: 0;
  }
}
</style>
